module.exports = __webpack_public_path__ + "media/images/lp_06-0408ab6763813fea71299dcd1f429ef7.webp";